import { ReactElement } from 'react';
import cn from 'classnames';
import styles from './ToggleInput.module.scss';
import { FieldProps, getIn } from 'formik';
import { useKeyboardClick } from '../../hooks/useKeyboardClick';
import { Icon } from '../Icon/Icon';
import { getDataTest } from '../../utils/dataTests';

interface ToggleInputProps extends FieldProps {
    id?: string;
    className?: string;
    value: string;
    label?: string;
    error?: string;
    active?: boolean;
    onClick?: () => void;
}

export const ToggleInput = ({
    className,
    field,
    form,
    value,
    label,
    onClick,
    active,
    ...props
}: ToggleInputProps): ReactElement | null => {
    const formValue = getIn(form.values, field.name);
    const isActive = active || value === formValue;

    const handleKeyDown = useKeyboardClick(() => {
        field.onChange({ target: { name: field.name, value } });
    });

    const handleClick = () => {
        field.onChange({ target: { name: field.name, value } });
        onClick && onClick();
    };

    return (
        <div
            className={cn(styles.wrapper, isActive && styles.wrapperActive, className)}
            tabIndex={0}
            onKeyDown={handleKeyDown}
            onClick={handleClick}
            {...props}
        >
            <span className={cn(styles.chip)}>
                <span className={cn(styles.iconWrapper)} data-test={getDataTest(props, 'Icon')}>
                    {isActive ? <Icon name="document-text" /> : <span className={cn(styles.icon)} />}
                </span>
                {label || value}
            </span>
        </div>
    );
};
